module.exports = __webpack_public_path__ + "img/hood_height.5683b11a.png";